import { Button, Input, Modal } from "semantic-ui-react";
import { deleteRoomReady } from "services/roomReadys";

export default function DeletePopup(props: any): JSX.Element {
  const { popup, setPopup, roomReady, fetchCount, setFetchCount } = props

  return (
    <Modal
      closeIcon
      style={{ width: "25rem" }}
      onClose={() => setPopup({ ...popup, delete: false })}
      open={popup.delete}
    >
      <Modal.Header className="text-left">
        <div>Remove record</div>
      </Modal.Header>
      <Modal.Content className="text-left">
        <div>
          You are about to remove this record with the confirmation no.:<b>{roomReady?.bookingNumber}</b>
        </div>
      </Modal.Content>
      <Modal.Actions >
        <Button color='black' onClick={() => setPopup({ ...popup, delete: false })}>
          Cancel
        </Button>
        <Button
          content="Delete"
          onClick={async () => {
            // console.log("delete?",roomReady)
            await deleteRoomReady(roomReady._id)
            setFetchCount(fetchCount + 1)
            setPopup({ ...popup, delete: false })
          }}
          color="red"
        />
      </Modal.Actions>
    </Modal>
  )
}
